import React, { useState, useEffect, useRef } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { isTokenValid, logoutAndRedirect } from '../utils/auth';

const FOOTER_BUFFER = 8;

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const stored = localStorage.getItem('sidebarOpen');
    return stored === 'true';
  });
  const [isMobile, setIsMobile] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const sidebarRef = useRef(null);
  const footerRef = useRef(null);
  const [footerHeight, setFooterHeight] = useState(80);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!isTokenValid(token)) {
      logoutAndRedirect();
      return;
    }

    const onStorage = (e) => {
      if (e.key === 'token') {
        const t = e.newValue;
        if (!isTokenValid(t)) logoutAndRedirect();
      }
    };
    window.addEventListener('storage', onStorage);

    const checkMobile = () => {
      setIsMobile(window.innerWidth < 992);
      setIsSmallScreen(window.innerWidth < 576);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  useEffect(() => {
    document.body.classList.add('no-body-scroll');
    return () => {
      document.body.classList.remove('no-body-scroll');
    };
  }, []);

  // Medir footer dinamicamente
  useEffect(() => {
    const updateFooterHeight = () => {
      const h = footerRef.current ? footerRef.current.offsetHeight : 80;
      setFooterHeight(h);
    };
    updateFooterHeight();

    let ro;
    if (typeof ResizeObserver !== 'undefined' && footerRef.current) {
      ro = new ResizeObserver(entries => {
        for (const entry of entries) {
          const h = entry.contentRect ? Math.ceil(entry.contentRect.height) : 80;
          setFooterHeight(h);
        }
      });
      ro.observe(footerRef.current);
    }

    return () => {
      if (ro) ro.disconnect();
    };
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(prev => {
      localStorage.setItem('sidebarOpen', !prev);
      return !prev;
    });
  };

  return (
    <div
      className="layout-container"
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <Navbar toggleSidebar={toggleSidebar} />
      <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} sidebarRef={sidebarRef} />

      <div
        className="full-screen-div"
        style={{
          backgroundImage: `url('/assets/desktop.png')`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          paddingTop: '48px',
          paddingBottom: '0px',
          paddingLeft: '0px',
          paddingRight: '0px',
          display: 'flex',
          flexDirection: 'column',
          flex: '1 1 auto',
          marginLeft: isMobile ? '0px' : (isSidebarOpen ? '220px' : '50px'),
          transition: 'margin-left 0.3s ease-in-out',
          minHeight: 0,
        }}
      >
        <div
          className="content-container"
          style={{
            flex: '1 1 auto',
            paddingTop: '15px',
            paddingBottom: `${footerHeight + (isSmallScreen ? 16 : FOOTER_BUFFER)}px`,
            paddingLeft: '15px',
            paddingRight: '15px',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
            minHeight: 0,
            transition: 'padding-left 0.3s ease-in-out',
          }}
        >
          {children}
        </div>
        <div ref={footerRef}>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Layout;
